/**
 * Copyright © 2026 Adnuntius AS.
 */
import {ChangeDetectorRef, Component, Inject, OnDestroy, OnInit} from '@angular/core';
import {UIRouter} from '@uirouter/core';
import * as _ from 'lodash';

import {OBJECT_TYPE} from '../../common/constants/object-type';
import {buildLastViewedEntries} from './simple-last-viewed.util';
import template from './creative-checker-page.component.html';
import {AdnTranslateService} from '../../common/filters/adn-translate.service';
import {AdnCheckerService} from '../../../components/util/adn-checker.service';
import {LocalNetworkProfile} from '../../../components/session/local-network-profile';
import {LocalUserProfile} from '../../../components/session/local-user-profile';
import {createBufferedFlag, readBufferedFlag} from '../../common/util/template-state';
import {NavigationHistoryService} from '../../../components/util/navigation-history.service';

@Component({
  standalone: false,
  selector: 'adn-creative-checker-page',
  template
})
export class CreativeCheckerPageComponent implements OnInit, OnDestroy {
  lastViewed: any[] = [];
  lastViewedObject: any;
  selectFrom = 'CUSTOM';

  loaded = true;
  private readonly loadedFlag = createBufferedFlag();
  private destroyed = false;
  objectId: string;
  objectType: any;
  objectTypes = OBJECT_TYPE;
  hashResults = true;
  forceRerun: boolean;
  ignoreScanHistory = '';
  results: any[];

  constructor(
    @Inject(LocalUserProfile) localUserProfile: any,
    @Inject(LocalNetworkProfile) LocalNetworkProfile: any,
    @Inject(AdnCheckerService) private readonly adnChecker: any,
    private readonly adnTranslate: AdnTranslateService,
    private readonly uiRouter: UIRouter,
    private readonly cdr: ChangeDetectorRef,
    navigationHistory: NavigationHistoryService
  ) {
    this.lastViewed = buildLastViewedEntries(localUserProfile, LocalNetworkProfile);
    this.lastViewedObject = _.get(this.lastViewed, [0]);
    this.objectId = navigationHistory.previousParams.id;
    this.objectType = _.find(_.values(OBJECT_TYPE), (ot) => ot.stateName === navigationHistory.previousState?.name);
  }

  get displayLoaded(): boolean {
    return readBufferedFlag(this.loadedFlag, this.loaded, this.cdr, () => !this.destroyed);
  }

  ngOnInit(): void {
    const creativeId = this.uiRouter.globals.params.creativeId;
    if (creativeId) {
      this.objectId = creativeId;
      this.doCheck();
    }
  }

  ngOnDestroy(): void {
    this.destroyed = true;
  }

  doCheck(): void {
    const id = this.selectFrom === 'LAST_VIEWED' ? this.lastViewedObject : this.objectId;
    this.loaded = false;
    this.adnChecker.checkId(id, this.forceRerun, this.hashResults, this.ignoreScanHistory === 'IGNORE').then((data: any) => {
      this.loaded = true;
      this.results = data.results;

      if (this.results[0]) {
        this.results[0].cookies = _.map(this.results[0].scan.cookies, (header: any) => {
          if (_.isString(header)) {
            const split = header.split(String.fromCharCode(31));
            return {
              name: split[0],
              value: split[1],
              expires: split[2],
              days: split[3]
            };
          }
          return header;
        });
      }
    });
  }

  translateViolation(violation: any): string {
    return this.adnTranslate.transform(violation.text, violation.code, violation.parameters);
  }

  scanNumber(index: number): number {
    return (this.results?.length || 0) - index;
  }
}
